import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Collapse } from 'antd'
import { GatewaySplitEditor, GatewaySplitRow } from '../../../../components/GatewaySplitEditor'
import warehouseSplitController from './warehouseSplit.controller'
import PaymentGatewayController from '../payment.gateway.controller'
import { openApi } from '../../../../helpers/request'
import i from '../../../../translations/i'

// Настройка распределения по конкретному складу — если для склада не задано ни одной
// строки, при оплате используется глобальное правило (см. Options-раздел "Разделение платежей").
// Список свёрнут по умолчанию (складов может быть много) — в заголовке видно текущее состояние.
export const WarehouseSplitSection = observer(({ context }: { context: string }) => {

  const [warehouses, setWarehouses] = useState<any[]>([])

  useEffect(() => {
    warehouseSplitController.get()
    PaymentGatewayController.getList()
    openApi('get', '/data_data')
      .then((result: any) => setWarehouses(result.data?.warehouses ?? []))
      .catch(error => console.log(error.response))
  }, [])

  if(!warehouseSplitController.render)
    return <></>

  return (
    <Collapse
      items={warehouses.map((warehouse: any) => ({
        key: warehouse.id,
        label: <WarehouseSplitSummary warehouse={warehouse} context={context} />,
        children: <WarehouseSplitEditorPanel warehouse={warehouse} context={context} />,
      }))}
    />
  )
})

const WarehouseSplitSummary = observer(({ warehouse, context }: { warehouse: any, context: string }) => {

  const rows = warehouseSplitController.rowsFor(warehouse.id, context)

  const summary = rows.length === 0
    ? null
    : rows.map((row) => {
        const gateway = PaymentGatewayController.list.find((g: any) => g.id === row.gateway_id)
        return `${gateway?.label ?? '—'} ${row.percent}%`
      }).join(', ')

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 12 }}>
      <span>{warehouse.name}</span>
      <span style={{ fontSize: 12, color: summary ? 'var(--primary-color)' : 'var(--text-muted-color)' }}>
        {summary ?? i.t('paymentOptions:notConfigured')}
      </span>
    </div>
  )
})

const WarehouseSplitEditorPanel = observer(({ warehouse, context }: { warehouse: any, context: string }) => {

  const [rows, setRows] = useState<GatewaySplitRow[]>(() => warehouseSplitController.rowsFor(warehouse.id, context))
  const [saving, setSaving] = useState(false)

  const handleSave = () => {
    setSaving(true)
    warehouseSplitController.save(warehouse.id, context, rows).finally(() => setSaving(false))
  }

  return (
    <>
      <GatewaySplitEditor rows={rows} onChange={setRows} />

      <Button style={{ marginTop: 8 }} size="small" type="primary" loading={saving} onClick={handleSave}>
        {i.t('def:actions.save')}
      </Button>
    </>
  )
})
